import {
  AfterViewChecked,
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  DoCheck,
  Input,
  OnInit,
} from '@angular/core';
import { FormGroup, FormBuilder, ReactiveFormsModule } from '@angular/forms';
import {
  CardModule,
  CheckboxModule,
  DropdownModule,
  RadioButtonModule,
  AlertModule,
  TooltipModule,
} from 'axis-components';
import { CommonModule, SlicePipe } from '@angular/common';
import { BaseRules, Control, TextValues } from './california-model';
import { UimuiBaseStateComponent } from '../uimui-base-state.component';
import { TruncateModule } from 'axis-components/truncate';

@Component({
  selector: 'app-california',
  standalone: true,
  imports: [
    CardModule,
    CheckboxModule,
    DropdownModule,
    CommonModule,
    ReactiveFormsModule,
    RadioButtonModule,
    AlertModule,
    SlicePipe,
    TruncateModule,
    TooltipModule
  ],
  templateUrl: './california.component.html',
  host: {
    class: 'state-wrapper',
  },
})
export class CaliforniaComponent extends UimuiBaseStateComponent<
  BaseRules,
  TextValues
> {
  @Input() set formGroup(form: FormGroup | null) {
    if (form) {
      super.getJsonRuleFiles('california', form);
    }
  }
  @Input() set isReview(review: boolean) {
    if (review) {
      super.getJsonRuleFiles('california', null);
    }
  }

  override eventHook(value: any) {
    if (
      'UMPD_Accepts_MandatoryCoverage_LevelTwo_Radio' === value
      // || 'Rejects_LevelTwoUMPDMandatory_Radio' === value
    ) {
      this.reactiveForm.get('levelTwoUMPDOptional_Radio').setValue({
        name: 'levelTwoUMPDOptional_Radio',
        selectedIndex: 1,
        value: 'Accepts_LevelTwoUMPDOptional_Radio',
      });
    }
  }
}
